import InstructionsLayout from "./instructions/InstructionsLayout.js";
import { useTheme } from "@emotion/react";
import { Typography, Button, Box, Icon } from "@mui/material";
import PersonalizeTags from "./blocks/tags/PersonalizeTags.js";
import { useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { customEvent } from "src/utils/gtag.js";
import { AuthContext } from "src/utils/AuthContext.js";
import { useUpdateTags } from "src/services/index.js";
import SignInDialog from "./blocks/dialogs/SignInDialog.js";
import { Helmet } from "react-helmet";
import { useSessionStorage } from "src/utils/useSessionStorage.js";

const Personalize = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { mutateAsync: updateTags } = useUpdateTags();
  const { user, refetchAuth } = useContext(AuthContext);
  const [openSignInDialog, setOpenSignInDialog] = useState(false);
  const [sessionTags, setSessionTags] = useSessionStorage("userTags", []);

  return (
    <>
      <Helmet>
        <title>Stanza - Personalize</title>
        <meta
          name="description"
          content="Personalize your Stanza experience by selecting tags that match your interests."
        />
      </Helmet>

      <InstructionsLayout>
        <Icon
          baseClassName="material-symbols-outlined"
          sx={{
            display: "block",
            margin: "0 auto",
            color: `${theme.palette.icon.primary}`,
            verticalAlign: "middle",
            fontSize: "4rem",
            mb: 1,
            fontWeight: 300,
          }}
        >
          auto_fix_high
        </Icon>
        <Typography variant={"h2"} sx={{ mb: 1 }}>
          Personalize Your Experience
        </Typography>
        <Typography variant={"subtitle2"} sx={{ mb: 6 }} color="text.secondary">
          Choose tags that match your interests.
        </Typography>

        <PersonalizeTags
          onTagChange={(action, tag) => {
            customEvent({
              name: `${action}_home_tag`,
              category: "HomeCalendarTags",
              label: `User or guest ${action} home tag`,
              data: {
                user_id: user?._id ?? "guest",
                user_email: user?.email ?? "-",
                user_handle: user?.handle ?? "no_handle",
                tag,
              },
            });
          }}
        />

        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px",
            backgroundColor: "background.paper",
            borderTop: 1,
            borderColor: "divider",
            display: "flex",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <Button
            variant="contained"
            size="grown"
            sx={{ width: "330px" }}
            onClick={async () => {
              if (!user) {
                setOpenSignInDialog(true);
              } else {
                navigate("/?tab=foryou");
              }
            }}
          >
            START DISCOVERING
          </Button>
        </Box>
      </InstructionsLayout>
      <SignInDialog
        open={openSignInDialog}
        handleClose={() => setOpenSignInDialog(false)}
        onSignIn={async () => {
          await updateTags({ tags: sessionTags });
          await refetchAuth();
          navigate("/?tab=foryou");
        }}
      />
    </>
  );
};

export default Personalize;
